export const RankBadge = ({ rank }: { rank: number }) => {
  switch (rank) {
    case 1:
      return <b>🥇</b>;
    case 2:
      return <b>🥈</b>;
    case 3:
      return <b>🥉</b>;
    default:
      return <b>{rank} </b>;
  }
};
